import yup from './yup'
import moment from 'moment-timezone'
import { AnnouncementStatus } from 'constants/index'

export const announcementFormSchema = yup.object().shape({
  announcementText: yup
    .string()
    .label('Announcement Text')
    .trimmedRequired('Announcement Text is required'),
  recipients: yup
    .array()
    .of(yup.string())
    .min(1, 'At least one recipient is required')
    .required('Recipients are required'),
  status: yup.string(),
  scheduledOn: yup.string().when('isScheduled', {
    is: true,
    then: yup
      .string()
      .required({ errType: 'Date', msg: 'This is required field.' })
      .test(
        'test',
        { errType: 'Time', msg: 'Schedule time must be after Current Time' },
        function (value) {
          const status = this.parent.status
          if (status === AnnouncementStatus.SCHEDULED) {
            const nowDateTime = moment()
            return nowDateTime.isSameOrBefore(moment(value))
          } else return true
        }
      ),
    otherwise: yup.string()
  })
})
